export enum RMAStatus {
  Created = 'created',
  PickedUp = 'picked_up',
  Closed = 'closed'
}
